class Constants {
  public static readonly API_NAME = "Viewpoint360API";
}

export { Constants };